import { t as e } from "../../chunks/icon-DRa__a4u.js";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
import r from "classnames";
import i from "lodash.uniqueid";
var a = {
	tickBoxWrapper: "_tickBoxWrapper_l55zw_1",
	labelWrapper: "_labelWrapper_l55zw_10",
	checkbox: "_checkbox_l55zw_16",
	checked: "_checked_l55zw_27",
	labelText: "_labelText_l55zw_31",
	checkmark: "_checkmark_l55zw_40",
	error: "_error_l55zw_50"
}, o = ({ checked: o, children: s, className: c, name: l = "check", onClick: u, shouldUseUniqueId: d, testId: f }) => /* @__PURE__ */ t("div", {
	className: r(a.tickBoxWrapper, c),
	"data-testid": f,
	onClick: (e) => {
		e.preventDefault(), u && u();
	},
	children: /* @__PURE__ */ n("label", { children: [/* @__PURE__ */ t("input", {
		autoComplete: "off",
		"data-testid": f ? `${f}-checkbox` : void 0,
		defaultChecked: o,
		id: d ? i(l) : l,
		type: "checkbox"
	}), /* @__PURE__ */ n("span", {
		className: a.labelWrapper,
		children: [/* @__PURE__ */ t("span", {
			className: `${a.checkbox} ${o ? a.checked : ""}`,
			children: o ? /* @__PURE__ */ t("span", {
				className: a.checkmark,
				children: /* @__PURE__ */ t(e, {
					fill: "#00182e",
					icon: "Checkmark"
				})
			}) : null
		}), /* @__PURE__ */ t("span", {
			className: a.labelText,
			children: s
		})]
	})] })
});
//#endregion
export { o as default };
